export default __webpack_public_path__ + "static/media/bike-2.eeb8ed1d.svg";